import React, { useContext } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { ModalContext } from "../../context/modal";
import { authApi } from "../../services/api";
import { DefaultButton, MyModalBody } from "../../style/default";
import { TOASTIFY_OPTIONS } from "../../style/global";

function DisableAccountModal({ open, populateTable, data }) {
	const { handleOpenModal } = useContext(ModalContext);

	const handleAccountDelete = async () => {
		try {
			await authApi.post(`/account/disable/${data._id}`);
			toast.success("Conta desativada com sucesso.", TOASTIFY_OPTIONS);
			populateTable();
			handleOpenModal();
		} catch (error) {
			handleOpenModal();
			console.error("error", error);
		}
	};

	return (
		<Modal
			transition={false}
			show={open}
			size="small"
			backdrop="static"
			onHide={handleOpenModal}
		>
			<Modal.Header closeButton closeLabel="">
				<Modal.Title>Desativar conta</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<MyModalBody>
					<h5>Deseja realmente desativar a conta: {data?.name}</h5>
				</MyModalBody>
			</Modal.Body>
			<Modal.Footer>
				<DefaultButton onClick={handleAccountDelete}>
					Desativar conta
				</DefaultButton>
			</Modal.Footer>
		</Modal>
	);
}

export { DisableAccountModal };
